export default {
    count: 0,
    currency: '',
    errors: [],
    items: [],
    itemsGA4: [],
    lastItem: null,
    open: false,
    reward: { offerName: null, secret: false, state: 'none', voucherName: null },
    total: 0,
    totalFormatted: '',
    validUntil: null,
    validity: '00:00',

    toggle() {
        this.open = !this.open;
        document.body.classList.toggle('basket-is-visible', this.open);
    },

    show() {
        this.open = true;
        document.body.classList.add('basket-is-visible');
    },

    hide() {
        this.open = false;
        document.body.classList.remove('basket-is-visible');
    },

    rewardMessage(reward) {
        if (!reward || !reward.offerName || reward.secret) return '';

        if (reward.state === 'earned' || reward.state === 'eligible') {
            return reward.offerName;
        }

        return '';
    },

    addRewardMessage(reward) {
        if (!reward || reward.state !== 'available' || reward.secret) return '';

        return `Add ${reward.voucherName}`;
    },
};
